<template>
  <div class="new-company-calculator" style="width: 100vw">
    <div class="column">
      <div class="column is-four-fifths" style="padding-left: 0rem !important">
        <b-field
          :label="$t('A. 年度之可課稅收益')"
          :message="$t(validation.firstError('icomeYear'))"
        >
          <p class="control">
            <b-button>MOP</b-button>
          </p>
          <b-input v-model="icomeYear"></b-input>
        </b-field>
      </div>

      <div v-if="isShowResult" class="table-container">
        <table
          class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth"
        >
          <thead class="has-text-centered">
            <tr>
              <th>{{ $t("由") }}</th>
              <th>{{ $t("至") }}</th>
              <th>{{ $t("稅率") }}</th>
              <th>{{ $t("該級可課稅收益") }}</th>
              <th>{{ $t("該級稅款") }}</th>
              <th>{{ $t("累計稅款") }}</th>
            </tr>
          </thead>
          <tbody class="has-text-centered">
            <tr>
              <td>0</td>
              <td>600,000</td>
              <td>0%</td>
              <td class="has-text-right">
                {{ formatNumberSimple(getFirstTypeIncome) }}
              </td>
              <td class="has-text-right">
                {{ formatNumber(getFirstTypeIncome * 0) }}
              </td>
              <td class="has-text-right">
                {{ formatNumberSimple(getFirstTypeIncome * 0) }}
              </td>
            </tr>
            <tr>
              <td colspan="2">600,000以上</td>
              <td>12%</td>
              <td class="has-text-right">
                {{ formatNumberSimple(icomeYear - getFirstTypeIncome) }}
              </td>
              <td class="has-text-right">
                {{ formatNumber(getSecondTypeTax) }}
              </td>
              <td class="has-text-right">
                {{ formatNumberSimple(allTax) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <table v-if="isShowResult" class="table is-fullwidth">
        <thead
          class="table table is-bordered is-striped is-narrow is-hoverable is-fullwidth"
        >
          <tr>
            <th class="is-half">{{ $t("B.應繳所得補充稅稅款") }}</th>
            <th class="is-half has-text-right">
              {{ "MOP " + formatNumberSimple(allTax) }}
            </th>
          </tr>
          <tr>
            <th class="is-half">B. {{ $t("incomeTax_discount") }}</th>
            <th class="is-half has-text-right">
              {{ "MOP " + formatNumberSimple(this.getDiscount) }}
            </th>
          </tr>
          <tr>
            <th class="is-half">C. {{ $t("incomeTax_allYear") }}</th>
            <th class="is-half has-text-right">
              {{ "MOP " + formatNumberSimple(this.getTotal) }}
            </th>
          </tr>
        </thead>

        <br />
        <thead class="table is-narrow is-fullwidth">
          <td rowspan="3" class="is-full">
            {{
              $t(
                "(1)計算結果僅供參考。而確定性可課稅金額以稅務當局所作之評定為準。"
              )
            }}
          </td>
        </thead>
        <thead class="table is-narrow is-fullwidth">
          <td rowspan="2" class="is-full is-fullwidth">
            {{ $t("(2)僅適用於2020年度取得的收益。") }}
          </td>
        </thead>
        <thead class="table is-narrow is-fullwidth">
          <td rowspan="2" class="is-full">
            {{ $t("(3)不足一元的部分，作一元計。") }}
          </td>
        </thead>
      </table>

      <b-button
        @click="calcute"
        class="is-primary"
        style="background-color: #00775e"
        >{{ $t("計算") }}</b-button
      >
    </div>
  </div>
</template>

<script>
import SimpleVueValidation from "simple-vue-validator";
import numeral from "numeral";
const Validator = SimpleVueValidation.Validator;

export default {
  name: "IncomeTax",
  props: [],
  data() {
    return {
      isShowResult: false,
      icomeYear: "",
      firstTypeIncome: "",
      firstTypeIncomeTax: "",
      calcuteValue: null,
    };
  },
  validators: {
    icomeYear: function(value) {
      return Validator.value(value)
        .required()
        .digit("請輸入規範的數值");
    },
  },
  methods: {
    formatNumberSimple(price) {
      return numeral(price).format("0,0.00");
    },
    formatNumber(price) {
      return numeral(Math.ceil(price)).format("0,0.00");
    },
    calcute() {
      this.$validate().then((success) => {
        if (success) {
          this.isShowResult = true;
        }
      });
    },
  },
  computed: {
    getFirstTypeIncome() {
      return Math.min(600000, this.icomeYear);
    },
    getSecondTypeTax() {
      return (
        (this.icomeYear - this.getFirstTypeIncome) * 0.12 -
        (this.getFirstTypeIncome * 0 - this.getFirstTypeIncome * 0)
      );
    },
    allTax() {
      return Math.ceil(this.getSecondTypeTax + this.getFirstTypeIncome * 0);
    },
    getDiscount() {
      if (this.allTax > 300000) {
        return 300000;
      }
      return this.allTax;
    },
    getTotal() {
      return this.allTax - this.getDiscount;
    },
  },
};
</script>
